define('modules/integrations/services/api/model',['require','exports','module','env','base/model'],function (require, exports, module) {
  'use strict';

  var Config = require('env'),
    BaseModel = require('base/model');

  var model = BaseModel.extend({
    initialize: function () {
      this.initRequestEvents();
    },

    url: function () {
      return Config.backendUrl + '/accounts/api-keys';
    },

  });

  module.exports = model;
});

